import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import NonsocialUpdate from "../nonsocial_update";
import Book, { VALID_BOOK_SIZES } from "../../book";
import UserStatusHeader from "../user_status/user_status_header";
import UserProfileLink from "../../user/user_profile_link";
import NewsfeedItemHeaderTimestamp from "../newsfeed_item_header_timestamp";
import NewsfeedItemFooterActions from "../footer/newsfeed_item_footer_actions";
import PreviewBook from "../../preview_book/preview_book";
import WantToReadButton from "../../want_to_read/want_to_read_button";
import ExpandableHtml from "../../user_content/expandable_html";
import random from "lodash";
import { isEmpty } from "lodash";

export default GrComponentFactory.createClass({
  displayName: "ReadingNotesCollectionNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape({
      book: GrPropTypes.book().isRequired,
      user: GrPropTypes.user().isRequired,
      headerText: React.PropTypes.string.isRequired,
      highlightText: React.PropTypes.shape(GrPropTypes.expandableHtml()),
      noteText: React.PropTypes.shape(GrPropTypes.expandableHtml()),
    }).isRequired,
    readingNotesLinkUrl: React.PropTypes.string.isRequired,
    resourceDisplayName: React.PropTypes.string.isRequired,
    resourceUrl: React.PropTypes.string.isRequired,
    updateIconUrl: React.PropTypes.string.isRequired,
  },

  renderReadingNotesLink() {
    const linkText = `See all of ${this.props.resource.user.viewableName}’s notes & highlights`;

    return (
      <a href={this.props.readingNotesLinkUrl}>
        {linkText}
      </a>
    );
  },

  renderBookBody() {
    return <div>
      <WantToReadButton
        bookTitle={this.props.resource.book.title}
        uniqueId={random(1000000).toString()}
        bookId={this.props.resource.book.bookId}
        showStars={true} />
    </div>;
  },

  renderReadingNote() {
    if (isEmpty(this.props.resource.highlightText) && isEmpty(this.props.resource.noteText)) {
      return null;
    } else {
      return (
        <div className="newsfeedNoteHighlightTextContainer newsfeedNoteHighlightTextContainer--withBottomBorder">
          {!isEmpty(this.props.resource.highlightText) &&
            <div className="newsfeedNoteHighlightTextContainer__highlightText">
              <ExpandableHtml {...this.props.resource.highlightText}/>
            </div>
          }
          {!isEmpty(this.props.resource.noteText) &&
            <div className="newsfeedNoteHighlightTextContainer__noteContainer">
              <div className="newsfeedNoteHighlightTextContainer__noteImage">
                <div className="gr-icon gr-icon--readingNotesIcon">
                  <span className="u-visuallyHidden">Note</span>
                </div>
              </div>
              <div className="newsfeedNoteHighlightTextContainer">
                <ExpandableHtml {...this.props.resource.noteText}/>
              </div>
            </div>
          }
        </div>
      );
    }
  },

  getFooterLinks() {
    return [<PreviewBook book={this.props.resource.book}/>, this.renderReadingNotesLink()];
  },

  renderHeader() {
    return <div>
      <UserProfileLink user={this.props.resource.user} className="u-marginRightTiny"/>
      <UserStatusHeader book={this.props.resource.book}
                        headerText={this.props.resource.headerText}/>
    </div>;
  },

  renderBody() {
    return <div>
        <NewsfeedItemHeaderTimestamp time={this.props.updatedAt}
                                     resourceDisplayName={this.props.resourceDisplayName}
                                     resourceUrl={this.props.resourceUrl}/>
        {this.renderReadingNote()}
        <Book {...this.props.resource.book}
          className={this.props.bookClassName}
          size={VALID_BOOK_SIZES.LARGE}>
          {this.renderBookBody()}
        </Book>
      </div>;
  },

  renderFooter() {
    return <NewsfeedItemFooterActions elements={this.getFooterLinks()} />;
  },

  render() {
    return <NonsocialUpdate
      {...this.props}
      header={this.renderHeader()}
      body={this.renderBody()}
      footer={this.renderFooter()}
    />;
  },
});
